import Analytics from '@withlocals/withlocals-analytics';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getLocaleFromPathname } from 'utils/RouteHelper';
import { path2GACategory } from 'utils/analytics';
import { useI18n } from '~/stores/i18n';

const RouteChangeTracker: React.FC = () => {
  const location = useLocation();
  const lang = useI18n((s) => s.lang);
  const prevCategoryRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const pathName = location.pathname;
    const parts = pathName.split('/').filter((x) => !!x);
    const localeInPath = getLocaleFromPathname(pathName);
    if (localeInPath) {
      parts.splice(0, 1);
    }

    const pageCategory = path2GACategory(pathName);
    const authCategories = ['Log in', 'Sign up'];
    const prev = (window as any).currentPageCategory as string | undefined;
    if (
      authCategories.includes(pageCategory) &&
      !authCategories.includes(prev || '')
    ) {
      (window as any).previousNonAuthPageCategory = prev;
    }
    (window as any).currentPageCategory = pageCategory;

    Analytics.page(parts.join('/'), {
      pathName,
      pageCategory,
      title: window.document.title,
      lang,
    });

    prevCategoryRef.current = pageCategory;
  }, [location.pathname, location.search, location.hash, lang]);

  return null;
};

export default RouteChangeTracker;
